import axios from 'axios';
const instance = axios.create({baseURL: 'https://api.mitsubishi.mylotspy.com/api/v1'});
export default instance;
